<template>
  <div class="notfound-page">
    <h1 class="page-title">404 Not Found</h1>
    <p class="message">
      お探しのページは見つかりませんでした。<br />
    </p>
    <!-- <div class="vendors">
      <div class="vendor-card" v-for="vendor in vendors" :key="vendor.name">
        <img :src="vendor.img" :alt="vendor.name" class="vendor-img" />
        <p class="vendor-name">{{ vendor.name }}</p>
        <a
          :href="vendor.link"
          class="vendor-btn"
        >
          詳細を見る
        </a>
      </div>
    </div> -->
  </div>
</template>
<!-- 
<script setup>
import vendor1 from '@/assets/rank-table/vendor-1.png'
import vendor2 from '@/assets/rank-table/vendor-2.png'
import vendor3 from '@/assets/rank-table/vendor-3.png'

const vendors = [
  {
    name: '給湯器駆けつけ隊',
    img: vendor1,
    link: '/gas/lp05'
  },
  {
    name: 'キンライサー',
    img: vendor2,
    link: '/gas/550e8400-e29b-41d4'
  },
  {
    name: '街角給湯相談所',
    img: vendor3,
    link: '/gas/lp05'
  }
]
</script> -->

<style scoped>
.notfound-page {
  max-width: 900px;
  margin: 60px auto;
  padding: 0 20px 60px;
  text-align: center;
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.page-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #e74c3c;
  margin-top: 0;
  padding-top: 30px;
}

.message {
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.8;
}

.vendors {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
  margin-bottom: 40px;
}

.vendor-card {
  background: #fff;
  border: 1px solid #ddd;
  padding: 20px;
  width: 300px;
  text-align: center;
  transition: transform 0.2s;
}

.vendor-img {
  width: 100%;
  height: auto;
  border-radius: 4px;
  margin-bottom: 12px;
}

.vendor-name {
  font-weight: bold;
  margin-bottom: 10px;
}

.vendor-btn {
  display: inline-block;
  padding: 8px 16px;
  background-color: #3f51b5;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 20px;
  transition: background-color 0.3s;
}

.back-button {
  display: inline-block;
  padding: 12px 24px;
  background-color: #607d8b;
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-weight: bold;
  margin-bottom: 20px;
}

.vendor-name { margin-top: 0; }

/* === スマホ調整 === */
@media (max-width: 600px) {
  .message { font-size: 0.8rem; }
  .page-title { font-size: 1.6rem; }
  .vendor-card { width: 400px; }
  .vendor-name { font-size: 1.2rem; margin-top: 0; }
  .vendor-btn { font-size: 1.3rem; font-weight: 600; padding: 10px 40px; }
}
</style>
